/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    blockquote: "blockquote",
    p: "p",
    a: "a",
    code: "code",
    pre: "pre",
    h3: "h3",
    ul: "ul",
    li: "li"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Babel Macro | v4 | v5"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["This functionality was removed in v6.1 due to lack of usage and unnecessary bloat for other consumers. ", _jsx(_components.a, {
          href: "https://github.com/styled-components/styled-components/issues/4064",
          children: "More info"
        })]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://babeljs.io/blog/2017/09/11/zero-config-with-babel-macros",
        children: "Babel macros"
      }), " are quickly gaining steam as a full-featured option to allow advanced code transpilation for zero-config projects like ", _jsx(_components.a, {
        href: "https://github.com/facebook/create-react-app",
        children: "create-react-app"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["If your scaffold is set up with ", _jsx(_components.a, {
        href: "https://github.com/kentcdodds/babel-plugin-macros",
        children: _jsx(_components.code, {
          children: "babel-plugin-macros"
        })
      }), ", then simply use the new ", _jsx(_components.code, {
        children: "styled-components/macro"
      }), " import instead of ", _jsx(_components.code, {
        children: "styled-components"
      }), ":"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import styled, { createGlobalStyle } from 'styled-components/macro'\n\nconst Thing = styled.div`\n  color: red;\n`\n\nconst GlobalStyle = createGlobalStyle`\n  body {\n    color: 'white';\n  }\n`\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["The macro incorporates all the functionality of ", _jsx(_components.a, {
        href: "/docs/tooling#babel-plugin",
        children: "our babel plugin"
      }), " while allowing the unejected tooling to handle the Babel part of the build process. Special thanks to ", _jsx(_components.a, {
        href: "https://github.com/lucleray",
        children: "Luc Leray (@lucleray)"
      }), " for making this happen!"]
    }), "\n", _jsx(_components.h3, {
      children: "EXPERIMENTAL Config"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://github.com/kentcdodds/babel-plugin-macros",
        children: _jsx(_components.code, {
          children: "babel-plugin-macros"
        })
      }), " uses ", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/cosmiconfig",
        children: _jsx(_components.code, {
          children: "cosmiconfig"
        })
      }), " to read a ", _jsx(_components.code, {
        children: "babel-plugin-macros"
      }), " configuration which\ncan be located in any of the following files up the directories from the\nimporting file:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: ".babel-plugin-macrosrc"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: ".babel-plugin-macrosrc.json"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: ".babel-plugin-macrosrc.yaml"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: ".babel-plugin-macrosrc.yml"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: ".babel-plugin-macrosrc.js"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "babel-plugin-macros.config.js"
        })
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "babelMacros"
        }), " in ", _jsx(_components.code, {
          children: "package.json"
        })]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["You can then specify the same options as ", _jsx(_components.a, {
        href: "/docs/tooling#babel-plugin",
        children: "our babel plugin"
      }), " in ", _jsx(_components.code, {
        children: "styledComponents"
      }), " entry:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "// babel-plugin-macros.config.js\nmodule.exports = {\n  // ...\n  // Other macros config\n  styledComponents: {\n    pure: true,\n  },\n}\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["For more information, see ", _jsx(_components.a, {
        href: "https://github.com/kentcdodds/babel-plugin-macros/blob/master/other/docs/author.md#config-experimental",
        children: "EXPERIMENTAL config for babel-plugin-macros "
      }), "."]
    }), "\n", _jsx(_components.h3, {
      children: "Enforce macro imports"
    }), "\n", _jsxs(_components.p, {
      children: ["You may want to ensure that objects are consistently imported from the macro across your project. This can be achieved by using a ", _jsx(_components.a, {
        href: "https://eslint.org/docs/rules/no-restricted-imports",
        children: _jsx(_components.code, {
          children: "no-restricted-imports"
        })
      }), " rule from ESLint:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-json",
        children: "\"no-restricted-imports\": [\n  \"error\",\n  {\n    \"paths\": [{\n      \"name\": \"styled-components\",\n      \"message\": \"Please import from styled-components/macro.\"\n    }],\n    \"patterns\": [\n      \"!styled-components/macro\"\n    ]\n  }\n]\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
